export default __webpack_public_path__ + "static/media/Silk-Serif-Medium.b4401f10.otf";